import { render, staticRenderFns } from "./DeveloperLeadKanbanView.vue?vue&type=template&id=a0ad45fe"
import script from "./DeveloperLeadKanbanView.vue?vue&type=script&lang=js"
export * from "./DeveloperLeadKanbanView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports